<template>
  <v-layout align-center justify-center>
    <v-card class="elevation-12">
      <v-toolbar color="color.base1" dark>
        <v-toolbar-title>パスワードリセット実行</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <h2>注意</h2>
        <h3>
          パスワードは、半角英字（大文字・小文字）と数字を含む8文字以上で入力する必要があります。
        </h3>
        <v-text-field
          v-model="requestPassword"
          label="新しいパスワード"
          class="mt-4"
          type="password"
        />
        <v-text-field v-model="retypePassword" label="確認" type="password" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <ExecAndCancelButtons
          :can-exec="validatePassword"
          :loading="loading"
          @clickExec="execResetPassword"
          @clickCancel="displayCancelConfirmModal = true"
          exec-text="送信"
        />
      </v-card-actions>
    </v-card>

    <ConfirmModal
      v-model="displayCancelConfirmModal"
      @clickOk="$router.push('/').catch(() => {})"
      message="ログイン画面に戻ります。よろしいですか？"
    />
    <v-dialog v-model="displayCompleteModal" persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          パスワードリセット完了
        </v-card-title>
        <v-card-text>
          パスワードのリセットが完了しました。<br />
          再度ログインしてください。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click.prevent="$router.push('/').catch(() => {})"
            dark
            color="color.base1"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ConfirmModal from '@/components/Shared/CrudUI/ConfirmModal'
import ExecAndCancelButtons from '@/components/Shared/CrudUI/ExecAndCancelButtons.vue'
import { actions as drawerActions } from '@/vuex/modules/ui/drawer/constants'
// todo model化
import Account from '@/api/account'

export default {
  components: { ConfirmModal, ExecAndCancelButtons },
  data() {
    return {
      requestPassword: '',
      retypePassword: '',
      displayCancelConfirmModal: false,
      displayCompleteModal: false,
      loading: false,
    }
  },
  computed: {
    validatePassword() {
      // 半角英字と数字両方を含む8文字以上
      const regex = /^(?=.*?[a-zA-Z])(?=.*?\d)[a-zA-Z\d]{8,}$/
      return (
        this.requestPassword === this.retypePassword &&
        regex.test(this.requestPassword)
      )
    },
  },
  created() {
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY, {
      flag: false,
    })
  },
  methods: {
    async execResetPassword() {
      const requestBody = {
        token: this.$route.query.token,
        password: this.requestPassword,
      }
      this.loading = true
      try {
        await Account.postResetPassword(requestBody)
      } catch (e) {
        const error = new Error('パスワードリセットに失敗しました。')
        this.loading = false
        throw error
      }
      this.displayCompleteModal = true
    },
  },
}
</script>
